// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


export default function() {




    function updateQuantity ( event ) {

        var clickedButton = $( this );

    	// get the quantity group container
    	var controls = clickedButton.closest( '.js-quantity-controls' );


    	// get quantity value
    	var input = controls.find( '.js-qty' );

        // get the current stock
        var stock = input.attr('max');

    	// quantity
    	var quantity = parseInt( input.val() );

        // get add element dom
        var add = controls.find('.add');

        // get the remove element dom
        var remove = controls.find('.minus');

        // update any clones
        var target = input.attr('name');

    	// increment / decrement value
    	if( clickedButton.hasClass('add') )
    	{
    		if( ! stock || quantity < stock )
    		{
    			input.val( quantity+1 );
    		}
    		else
    		{
    			input.val( quantity );
    		}
    	}
    	else if ( clickedButton.hasClass( 'minus' ) )
    	{

    		// prevent quantity going lower than 0
    		if( quantity > 0 )
    		{
				input.val( quantity-1 );
    		}
    		else
    		{
    			input.val( 0 );
    		}

    	}

        input.trigger('change'); // fire any events that are waiting for the input to change (useful on cart page)

    	// prevent functionality
    	event.preventDefault();

    }

    function bindEvents () {

        $('body').on( 'click', '.js-quantity', updateQuantity );

    }

    function init() {

        // run events
        bindEvents();

    }

    // auto executes.
    init();

}
